(() => {
  const root = document.querySelector('[data-bb-auth]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-bb-auth-form]');
  const email = form.elements.login_hint;
  const submit = form.querySelector('[type=submit]');
  const status = root.querySelector('[data-bb-auth-status]');
  const heading = root.querySelector('h1');
  const label = root.querySelector('[data-bb-auth-submit-label]');
  const states = {
    'sign-in': ['Welcome back.', 'Your orders. Your status. Your account.', 'Sign in with a secure email code. No password needed.', 'Continue with email'],
    join: ['Your account starts here.', 'One account. Your orders and rewards.', 'New here? Verify your email to create your account, then choose your member username. No password needed.', 'Continue to join'],
    'access-help': ['Let’s get you back in.', 'Get back into your account.', 'Continue securely to request a new sign-in code.', 'Continue to account access'],
  };
  let active = 'sign-in', submitting = false, timer;
  // Permit storefront destinations only. Never store email, passwords or tokens.
  function safeReturn(value) {
    const fallback = '/pages/my-blueprint';
    if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020]/.test(value)) return fallback;
    try {
      const url = new URL(value, location.origin), path = decodeURIComponent(url.pathname);
      if (url.origin !== location.origin || /[\\\u0000-\u0020]/.test(path)) return fallback;
      if (!/^\/(?:pages\/(?:my-blueprint|rewards|rewards-guide)|cart|search)\/?$/.test(path) && !/^\/(?:products|collections)\/[a-z0-9-]+\/?$/.test(path)) return fallback;
      const safe = new URL(url.pathname, location.origin);
      for (const [key, val] of url.searchParams) if (['variant','q','type','sort_by'].includes(key) || key.startsWith('filter.')) safe.searchParams.set(key,val);
      if (/^#[a-z0-9-]+$/i.test(url.hash)) safe.hash = url.hash;
      return safe.pathname + safe.search + safe.hash;
    } catch { return fallback; }
  }
  const query = new URLSearchParams(location.search);
  const memberTabs = ['overview','loyalty','orders','leaderboard','referrals','creator','achievements','wishlist','profile','settings'];
  const initialHash = location.hash.slice(1);
  const intended = query.get('return_to') || (memberTabs.includes(initialHash) ? `/pages/my-blueprint#${initialHash}` : '/pages/my-blueprint');
  const destination = new URL(safeReturn(intended), location.origin);
  function syncReturn() {
    // Shopify can initialize theme metadata after this deferred script, and can
    // remove the preview query from the address bar. Re-check on submission.
    const previewId = query.get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' ? String(window.Shopify?.theme?.id || '') : '');
    if (/^\d+$/.test(previewId)) destination.searchParams.set('preview_theme_id',previewId);
    form.elements.return_to.value = destination.pathname + destination.search + destination.hash;
  }
  syncReturn();
  function resetBusy() { clearTimeout(timer); submitting=false; submit.disabled=false; form.removeAttribute('aria-busy'); label.textContent=states[active][3]; }
  function showState(name, focus=false) {
    active=Object.hasOwn(states,name) ? name : 'sign-in'; resetBusy();
    const copy=states[active]; heading.textContent=copy[0];
    root.querySelector('[data-bb-auth-intro]').textContent=copy[1];
    root.querySelector('[data-bb-auth-hint]').textContent=copy[2]; label.textContent=copy[3];
    root.querySelector('[data-bb-auth-help]').hidden=active!=='access-help';
    root.querySelector('[data-bb-auth-support]').hidden=active!=='access-help';
    root.querySelector('.bb-auth__help-link').hidden=active==='access-help';
    root.querySelectorAll('.bb-auth__tabs a').forEach(a=>{ if(a.dataset.bbAuthState===active)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current'); });
    status.textContent='';email.removeAttribute('aria-invalid');if(focus)heading.focus({preventScroll:true});
  }
  root.addEventListener('click',event=>{ const link=event.target.closest('[data-bb-auth-state]');if(!link)return;event.preventDefault();history.replaceState(null,'',`#${link.dataset.bbAuthState}`);showState(link.dataset.bbAuthState,true); });
  window.addEventListener('hashchange',()=>{if(Object.hasOwn(states,location.hash.slice(1)))showState(location.hash.slice(1));});
  email.addEventListener('input',()=>{email.removeAttribute('aria-invalid');status.textContent='';});
  email.addEventListener('invalid',()=>{email.setAttribute('aria-invalid','true');status.textContent='Enter a valid email address to continue.';});
  form.addEventListener('submit',event=>{
    if(submitting){event.preventDefault();return;}
    if(!navigator.onLine){event.preventDefault();status.textContent='You’re offline. Reconnect, then try again.';return;}
    syncReturn();email.value=email.value.trim();submitting=true;submit.disabled=true;form.setAttribute('aria-busy','true');label.textContent='Opening secure sign-in…';status.textContent='';
    // Native GET to Shopify. Never intercept or imitate provider authentication.
    timer=setTimeout(()=>{resetBusy();status.textContent='Still here? Please try again, or check your connection.';},12000);
  });
  window.addEventListener('pageshow',()=>{syncReturn();resetBusy();status.textContent='';});
  showState(Object.hasOwn(states,initialHash)?initialHash:'sign-in');
  if(query.has('error'))status.textContent='Sign-in wasn’t completed. Please try again with email.';
})();
